import React from 'react';
import { PatientFilter, TeamFilter } from '../filters/Filters';
import {
	CurrentPeriodonly,
	DaysRemainingFromFilter,
	DaysRemainingToFilter,
	EpisodeInsuranceFilter,
	StartDateFromFilter,
	StartDateToFilter,
	VisitTotalFromFilter,
	VisitTotalToFilter
} from './TotalFilters';
import { EpisodeTotalsTable } from './EpisodeTotalsTable';
import type { SieveFilterModel } from '~/util/sieve/filter';
import { DataTableFilterInjectContextProvider } from '~/shared/data-tables/query/DataTableFilterInjectContext';
import { QueryDataTableFilterBar } from '~/shared/data-tables/query/QueryDataTableFilterBar';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';

export function EpisodeTotals() {
	const defaultFilters: SieveFilterModel[] = [{ name: 'isCurrentPeriod', operator: '==', value: true }];
	return (
		<div className="space-y-6">
			<DataTableFilterInjectContextProvider defaultFilters={defaultFilters}>
				<QueryDataTableFilterBar>
					<FilterBar.Item label="Patient">
						<PatientFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Team">
						<TeamFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Insurance">
						<EpisodeInsuranceFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Start Date">
						<StartDateFromFilter />
						<FilterBar.Separator />
						<StartDateToFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Visit Total">
						<VisitTotalFromFilter />
						<FilterBar.Separator />
						<VisitTotalToFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Days Remaining In Period">
						<DaysRemainingFromFilter />
						<FilterBar.Separator />
						<DaysRemainingToFilter />
					</FilterBar.Item>
					<FilterBar.Item>
						<CurrentPeriodonly />
					</FilterBar.Item>
				</QueryDataTableFilterBar>

				<EpisodeTotalsTable />
			</DataTableFilterInjectContextProvider>
		</div>
	);
}
